module.exports = __webpack_public_path__ + "static/img/orderDefault.c630f048.png";